
/** module toxi/math/noise 
	@api public
*/
module.exports = {
	PerlinNoise: require('./noise/PerlinNoise'),
	simplexNoise: require('./noise/simplexNoise')	
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/math/noise.js
// module id = 4622
// module chunks = 14